// Leserecht je Admin-Seite (Pfad-Praefix). Gespiegelt aus den RequirePerm(...:read)
// der Listen-Endpunkte in backend/internal/handlers/*.go — NUR belegte Eintraege:
// eine Seite ohne Eintrag wird nie ausgeblendet (der Server bleibt massgeblich).
// Wer im Backend ein Leserecht ergaenzt, traegt die Seite hier nach.
const PAGE_READ_PERMS: Array<[prefix: string, perm: string]> = [
  ['/invoices', 'invoices:read'],       // invoices.go
  ['/credit-notes', 'invoices:read'],   // credit_notes.go
  ['/quotes', 'invoices:read'],         // quotes.go
  ['/dunning', 'invoices:read'],        // dunning.go
  ['/payments', 'payments:read'],       // payments.go
  ['/banking', 'payments:read'],        // banking.go
  ['/camt-import', 'payments:read'],    // camt53.go
  ['/sepa-mandates', 'payments:read'],  // sepa.go
  ['/ledger', 'payments:read'],         // ledger.go
  ['/contracts', 'subscriptions:read'], // contracts.go
  ['/terminate-reviews', 'subscriptions:read'],     // terminate_reviews.go
  ['/license-reset-reviews', 'subscriptions:read'], // license_reset.go
  ['/orders', 'orders:read'],           // orders.go
  ['/domains', 'dns:read'],             // domains.go
  ['/team', 'team:read'],               // team.go
  ['/portal-users', 'customers:read'],  // portal_users_admin.go
]

// pageReadPerm returns the read permission guarding a route (longest prefix wins).
export function pageReadPerm(pathname: string): string | undefined {
  let best: [string, string] | undefined
  for (const e of PAGE_READ_PERMS) {
    if ((pathname === e[0] || pathname.startsWith(e[0] + '/')) && (!best || e[0].length > best[0].length)) best = e
  }
  return best?.[1]
}
